import { connect } from 'react-redux';
import MutasiKeluar2 from '../../../views/Student/DataSiswa/MutasiKeluar2.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import {
  getClasses, getStudentPeriodOptions, getParamOptions, getParamOptionsAcademics, getPeriodsOptions,
} from '../../../states/thunks/options.thunk';
import {
  saveMoveRecord, listMoveRecord, getMoveRecord, editMoveRecord,UploadMoveRecord
} from '../../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    user: state.user,
    classes: state.options.classes,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetStudent: () => dispatch(getStudent()),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleGetMoveRecord: payload => dispatch(getMoveRecord(payload)),
    handleSaveMoveRecord: (payload, goback) => dispatch(saveMoveRecord(payload, goback)),
    handleListMoveRecord: (payload, goback) => dispatch(listMoveRecord(payload, goback)),
    handleEditMoveRecord: (payload, goback) => dispatch(editMoveRecord(payload, goback)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getStudentPeriodOptions: payload => dispatch(getStudentPeriodOptions(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleUpload: (payload, goback) => dispatch(UploadMoveRecord(payload, goback)),
  
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(MutasiKeluar2);
